<template>
  <div class="row mb-1">
    <div id="grafik-tren" class="col-md-12 px-gap">
      <div class="card card-default shade mt-2">
        <div class="card-body">
          <div class="row">
            <div class="col-md-12 col-sm-12">
              <div class="pull-left m-t-5 m-b-5">
                <h4 class="m-b-0">Grafik Tren Media Online</h4>
                <p class="small hint-text">Grafik Tren Media Online</p>
              </div>
              <div class="pull-right">
                <div class="form-check form-check-inline switch m-t-20 m-b-0">
                  <input type="checkbox" v-model="show_grafik" id="pagesSwitch" />
                  <label for="pagesSwitch">Tampilkan Grafik Bar</label>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <loader-component style="margin: auto" v-if="data === null" />
            <div v-else-if="Object.keys(data.stats).length === 0" class="alert alert-danger col-md-2 col-sm-2"
              id="errorApiEl" role="alert" align="center">
              <strong> Mohon maaf, data tidak tersedia! </strong>
              <br />
              Tidak dapat menampilkan grafik dengan data kosong.
            </div>
            <div v-else class="col-md-2 col-sm-2">
              <div v-if="!show_grafik">
                <!-- <div class="analytic-card">
                  <p>MEDIA CETAK</p>
                  <h4 style="color: #6c757d !important">
                    <i class="bi bi-newspaper"></i>
                    {{
                      data === null || Object.keys(data.stats).length == 0
                      ? "0"
                      : data.stats.media_cetak | thousandSeparator
                    }}
                  </h4>
                </div>
                <div class="analytic-card">
                  <p>MEDIA TV</p>
                  <h4 style="color: #e83e8c !important">
                    <i class="bi bi-tv"></i>
                    {{
                      data === null || Object.keys(data.stats).length == 0
                      ? "0"
                      : data.stats.media_tv | thousandSeparator
                    }}
                  </h4>
                </div> -->
                <div class="analytic-card">
                  <p>MEDIA ONLINE</p>
                  <h4 style="color: #28a745 !important">
                    <i class="bi bi-globe-americas"></i>
                    {{
                      data === null || Object.keys(data.stats).length == 0
                      ? "0"
                      : data.stats.news | thousandSeparator
                    }}
                  </h4>
                </div>
              </div>
              <!-- <div v-else>
                <pie-chart-component :data="data_pie" :config="config_pie" :height="350" />
              </div> -->
            </div>
            <div class="col-md-10 col-sm-10">
              <loader-component v-if="data == null" />
              <div v-else-if="Object.keys(data.grafik).length === 0" class="alert alert-danger" id="errorApiEl"
                role="alert" align="center">
                <strong>Mohon maaf, data tidak tersedia! </strong>
                <br />
                Tidak dapat menampilkan grafik dengan data kosong.
              </div>
              <line-chart-component v-else-if="!show_grafik" :series="data.grafik" el="linechart-tren-formed"
                mode="dual" />
              <dynamic-chart-component v-else-if="show_grafik" :config="configTren" chart_id="garfik-media-cetak-tren" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

import line_chart from "@/views/components/chart/line_chart.vue";
// import pie_chart from "@/views/components/chart/pie_chart.vue";
import loader from "@/views/components/loader.vue";
import dynamic_chart from "@/views/components/chart/dynamic_chart.vue";
import gp from "@/plugins/generalPlugins.js";

export default {
  name: "DataTrenFormed",
  components: {
    "line-chart-component": line_chart,
    // "pie-chart-component": pie_chart,
    "loader-component": loader,
    "dynamic-chart-component": dynamic_chart,
  },
  data() {
    return {
      show_grafik: false,
      configTren: null,
      data_pie: [],
      config_pie: {
        align: "center",
      },
    };
  },
  props: {
    data: {
      type: Object,
      default: function () {
        return {};
      },
    },
    databar: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  methods: {
    assemblePieChart() {
      if (Object.keys(this.data.stats).length > 0) {
        this.data_pie = [
          // {
          //   color: "#6c757d",
          //   name: "Media Cetak",
          //   y: parseInt(this.data.stats.media_cetak),
          // },
          // {
          //   color: "#e83e8c",
          //   name: "Media TV",
          //   y: parseInt(this.data.stats.media_tv),
          // },
          {
            color: "#28a745",
            name: "Media Online",
            y: parseInt(this.data.stats.news),
            source: 'news'
          },
        ];
      }
    },
  },
  created: function () {
    let self = this
    let data = this.data
    if (this.data) {
      this.assemblePieChart();
    }
    if (this.databar) {
      this.configTren = {
        chart: {
          type: "column",
          backgroundColor: "transparent",
        },
        credits: {
          enabled: false,
        },
        title: {
          text: "",
        },
        xAxis: {
          categories: this.data.grafik.x,
        },
        yAxis: {
          title: {
            text: "Berita",
          },
          min: 0,
          stackLabels: {
            enabled: true,
            style: {
              fontWeight: "bold",
              textOutline: false
            },
          },
          labels: {
            formatter: function () {
              return gp.kmbFormatter(this.value); 
            }
          }
        },
        legend: {
          align: "center",
        },
        tooltip: {
          headerFormat: "<b>{point.x}</b><br/>",
          pointFormat: "{series.name}: {point.y}<br/>Total: {point.stackTotal}",
        },
        plotOptions: {
          column: {
            stacking: "normal",
            dataLabels: {
              enabled: true,
              style: {
                textOutline: false
              },
            },
          },
          series: {
            label: {
              connectorAllowed: false,
            },
            point: {
              events: {
                click: function () {
                  let source = data.grafik.source
                  let query = data.grafik.query
                  let start = "";
                  let end = "";
                  let params = {};
                  let tgl = this.category.split(" ");
                  let tgl_str = tgl[2] + "-" + tgl[1] + "-" + tgl[0];
                  tgl = moment(tgl_str, "YYYY-MMM-DD");
                  if (tgl.isValid()) {
                    start = tgl.format("YYYY-MM-DD 00:00:00");
                    end = tgl.format("YYYY-MM-DD 23:59:59");
                  } else {
                    start = moment(self.$route.query.from).format(
                      "YYYY-MM-DD HH:mm:ss"
                    );
                    end = moment(self.$route.query.to).format(
                      "YYYY-MM-DD HH:mm:ss"
                    );
                  }

                  params = {
                    from: start,
                    to: end,
                  };

                  if ("topic_selected" in self.$route.query) {
                    params.topic_selected = self.$route.query.topic_selected;
                  }
                  if ("cakupan" in self.$route.query) {
                    params.cakupan = self.$route.query.cakupan;
                  }

                  if (source) {
                    params.sources = btoa(source);
                  }

                  if (query) {
                    params.q = query;
                  }
                  
                  self.$router.push({ path: "/posts", query: params });
                },
              },
            },
          },
        },
        series: this.data.grafik.y,
      };
    }
  },
};
</script>

<style scoped>
.analytic-card {
  padding: 5px 20px;
}
</style>